import React from 'react';;

export default function SkipLink() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[9999] focus:rounded-lg focus:px-4 focus:py-2 focus:text-sm focus:font-medium"
      style={{
        background: '#7CFF6B',
        color: '#07110D',
      }}
      onClick={(e) => {
        e.preventDefault();;
        const main = document.getElementById('main-content');;
        if (main) {
          main.setAttribute('tabindex', '-1');;
          main.focus();;
          main.removeAttribute('tabindex');;
        }
      }}
    >
      Skip to main content
    </a>
  );;
}
